import axios from "axios"
import { saveAs } from "file-saver"

const base = "/api/vip/manage"
const options = () => ({ headers: { Authorization: localStorage.getItem("token") } })
const url = (id) => `${base}/entries/${encodeURIComponent(id)}`

export default {
  entries: (params) => axios.get(`${base}/entries`, { ...options(), params }).then((res) => res.data),
  save: (entry) => axios.put(url(entry._id), entry, options()).then((res) => res.data),
  remove: (entry) => axios.delete(url(entry._id), { ...options(), data: { revision: entry.revision } }).then((res) => res.data),
  async download(params) {
    try {
      const { data } = await axios.get(`${base}/export`, { ...options(), params, responseType: "blob" })
      saveAs(data, "vip-2026-11-08.xlsx")
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try { error.response.data = JSON.parse(await error.response.data.text()) } catch (_) { /* Retain original error. */ }
      }
      throw error
    }
  },
}
